<template>
<div class="d-flex flex-column update-container"> 
  <header class="masthead mb-auto">
      <nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
				<div class="container-fluid">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<ul class="navbar-nav ml-auto align-items-center navWithSearch">
					<li class="nav-item">
              <a class="nav-link" href="#" tabindex="-1" aria-disabled="true">
                <img
                  v-bind:src="require(`@/assets/img/${this.n}.png`)"
                  alt
                  height="40px"
                  width="40px"
                  style="vertical-align: top"
                />
              </a>
            </li>
           <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="dropdown01"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                > </a
              >
              <div
                class="dropdown-menu dropdown-menu-right front"
                aria-labelledby="dropdown01"
              >
                <span class="dropdown-menu-arrow"></span>
                <a class="dropdown-item front" href="/#/profile2"> Manage Profile</a>
                <a class="dropdown-item front" href="/#/account">Account</a>
                <a class="dropdown-item front" href="/#/mediaCenter">Help Center</a>
                <a class="dropdown-item pointer front" @click="logout">Sign Out</a>
              </div>
            </li>
					</ul>
				</div>
			</nav>
    </header>
  <div class="d-flex flex-column ">
    <section class="py-5 bg-grey200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="card custom-card">
              <div class="card-body">
                <h5 class="text-center text-green mt-4">UPDATE YOUR EMAIL</h5>
                <div class="content row justify-content-center">
                  <div
                    class="currentEmail form-group col-md-6 mt-4 mb-3 bg-grey200 border-black"
                  >
                    <p class="emailhead">Current Email</p>
                    <p class="email1">{{ this.email }}</p>
                  </div>
                  <div class="form-group input1 col-md-7 mt-3 mb-3">
                    <input
                      type="email"
                      class="form-control"
                      @focus="removeinvalidemail"
                      id="exampleInputEmail1"
                      v-model="userid"
                      aria-describedby="emailHelp"
                      placeholder="New Email"
                    />
                    <label class="text-center pt-2 error1" v-if="invalidemail"
                      >Invalid Email</label
                    >
                  </div>
                  <div class="form-group input1 col-md-7 mt-3 mb-3">
                    <input
                      type="password"
                      class="form-control"
                      id="password"
                      v-model="password"
                      aria-describedby="password"
                      placeholder="Current Password"
                    />
                  </div>
                  <div
                    class="forgotPassword pb-3 input1 col-md-7 text-green"
                    @click="forgotPassword"
                  >
                    Forgot your password?
                  </div>
                </div>
                <div class="row justify-content-center mt-4 mb-3">
                  <div class="col-md-12 text-center">
                    <button
                      class="btn btn-lg btn-outline-light ml-7"
                      v-on:click.stop.prevent="UpdateEmail"
                    >
                      SAVE
                    </button>
                    <button
                      type="button"
                      @click="cancelChange"
                      class="btn btn-lg btn-light  ml-lg-5"
                    >
                      CANCEL
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  </div>
</template>

<style scoped>
.content {
  align-content: center !important;
  align-items: center;
  justify-content: center !important;
}
.error1 {
  font-size: 12px;
  color: rgba(255, 0, 0, 0.726);
  margin-bottom: 0px;
}
.emailhead {
  font-size: 15px;
  margin-top: 4px !important;
  margin-bottom: 0px !important;
  color: var(--text-primary-color);
}

.email1 {
  font-size: 13px;
  margin-top: 0px !important;
  margin-bottom: 4px !important;
  color: var(--text-primary-color);
}

.currentEmail {
  border-radius: 4px;
  border-color:  rgba(15, 15, 15, 0.568) !important;
  border-width: 1px !important;
  border-style: solid;
}

input {
  width: 95%;
  height: 45px;
  box-sizing: border-box;
}

.input1 {
  align-items: center !important;
  padding-left: 4%;
}

.forgotPassword {
  cursor: pointer;
}
.py-5{
  padding-top: 8rem !important;
  padding-bottom: 5rem !important;
min-height: 80vh;
}
</style>

<script>
export default {
  name: "UpdateEmail",
  components: {},
  computed: {
    
  },
  created() {
    this.$store.commit("showPopup", false);
    this.$store.commit("showdefaultFooter", true);
    this.$store.dispatch("account").then((res) => {
      this.$store.commit("setLoader", true);
      this.metaData = res.response.profile.metaData;
      this.email = res.response.profile.username;
      this.firstName = res.response.profile.first_name;
      this.lastName = res.response.profile.last_name;
      this.telephone  = res.response.profile.telephone;
      var n =  res.response.profile.metaData.image_id;
      if(n){
         this.n = n 
      } else {
        this.n = this.n
      }
      this.$store.commit("setLoader", false);
    });
  },
  mounted() {
    window.scroll(0, 0);
  },

  methods: {
    removeinvalidemail() {
      this.invalidemail = false;
    },

userNotLoggedin() {
			if( this.$store.state.user.logedin){
				return true
			} else{
				return false
			}
		},

    forgotPassword() {
      this.$router.push("/forgotpasswordemail");
    },
    cancelChange() {
      this.$router.push("/account");
    },
    logout() {
      this.$store.dispatch("logout").then((res) => {
        if (res == "true") {
          this.$router.push("/");
        }
      });
    },
    gotoAppStore(type) {
      if (type == "google") {
        window.open(
          "https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
          "_blank"
        );
      } else if (type == "apple") {
        window.open(
          "https://apps.apple.com/gm/app/ibakatv/id1060646446",
          "_blank"
        );
      }
    },
    togglePopupNumbers(ev) {
      if (ev == "show") {
        this.showPopupNumbers = true;
      } else {
        this.showPopupNumbers = false;
      }
    },
    gotoSingin() {
      this.$router.push("/login");
    },
    removeErr() {
      this.showresmsg = false;
    },
    ValidateEmail(mail) {
      var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (mail.match(mailformat)) {
        return true;
      } else {
        // alert("You have entered an invalid email address!");
        return false;
      }
    },
    UpdateEmail() {
      var self = this;
      if (this.ValidateEmail(this.userid)) {
        this.invalidemail = false;
        var dataToSend = {
          id: this.email,
          password: this.password,
          type: "email",
        };
        this.$store.commit("setLoader", true);
        this.$store
          .dispatch("login", dataToSend)
          .then((res) => {
            var dataToSend = {
              metaData: this.metaData,
              email: this.userid,
              email1:this.email,
              firstName: this.firstName,
              lastName: this.lastName,
              telephone: this.telephone
            };
            this.$store
              .dispatch("UpdateEmail", dataToSend)
              .then((updateresponse) => {
                this.$store
                  .dispatch("triggerEmailverify", dataToSend)
                  .then((res) => {
                    if (res) {
                      self.$store.commit(
                        "setNotification",
                        updateresponse.message
                      );
                      self.$store.commit("setLoader", false);
                      this.$store.commit("setNotification", res.message);
                      self.$store.commit("setLoader", false);
                      this.$store.commit("logoutUser");
                      this.$router.push("/login");
                    }
                  })
                  .catch((err) => {
                    this.$store.commit("setLoader", false);
                    self.$store.commit(
                      "setNotification",
                      err.response.data.error.message
                    );
                  });
              })
              .catch((err) => {
                self.$store.commit("setLoader", false);
                self.$store.commit(
                  "setNotification",
                  err.response.data.error.message
                );
              });
          }) .catch((err) => {
                self.$store.commit("setLoader", false);
                self.$store.commit(
                  "setNotification",
                  err.response.data.error.message
                );
              });
          
      } else {
        this.invalidemail = true;
      }
    },
  },

  data() {
    return {
      showPopupNumbers: false,
      isActive: false,
      userid: "",
      invalidemail: false,
      invalidpassword: false,
      password: "",
      email: "",
      firstName: "",
      lastName: "",
      metaData: {},
      telephone:"",
      n : 0
    };
  },
};
</script>
